import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'ThumbnailImage' })
export class ThumbnailImage implements PipeTransform {
  transform(value: string): string {
    return value.replace('GetImage', 'GetImageThumbnail');
  }
}
